import React from 'react';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';

import Checkbox from '@/src/components/common/Checkbox/Checkbox';
import { RootState } from '@/src/reducers/types';

interface SelectProps {
  file: any;
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
}

const Select: React.FC<SelectProps> = ({ file, provided, snapshot }) => {
  const dispatch = useDispatch();
  const files = useSelector((state: RootState) => state.files);

  const selectedFiles = files.selectedItems.filter((f) => f.type === 'document').length;
  const selectedFolders = files.selectedItems.filter((f) => f.type !== 'document').length;

  const handleSelect = () => {
    dispatch({
      type: 'TOGGLE_SELECTED_IN_SELECTED_ITEMS',
      file: file,
    });
  };

  return (
    <div className="fileIndicators">
      <div className="moveIndicatorContainer" style={{ position: 'relative' }}>
        <div
          className={`dragHandle ${snapshot.isDragging ? 'dragging' : ''}`}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {snapshot.isDragging ? (
            (selectedFiles > 0 || selectedFolders > 0) && file.isSelected ? (
              <div className="selectedCount">
                {selectedFiles > 0 && (
                  <span>
                    <i className="material-icons">description</i>
                    <i className="counter">{selectedFiles}</i>
                  </span>
                )}
                {selectedFolders > 0 && (
                  <span>
                    <i className="material-icons">folder</i>
                    <i className="counter">{selectedFolders}</i>
                  </span>
                )}
              </div>
            ) : (
              <div className="selectedCount singleSelected">
                <span>
                  <i className="material-icons">
                    {file.type === 'folder' ? 'folder' : 'description'}
                  </i>
                  <i className="counter">1</i>
                </span>
              </div>
            )
          ) : null}
        </div>
        <i className="material-icons dragIcon">drag_indicator</i>
      </div>
      <Checkbox checked={file.isSelected} onChange={handleSelect} />
    </div>
  );
};

export default Select;
